import { useAudienceStore } from "@/lib/stores/audienceStore";
import { useAuthStore } from "@/lib/stores/authStore";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export type AdultRouteContext = {
  audience: "adult";
};

export const Route = createFileRoute("/(content)/adults")({
  beforeLoad: () => {
    const { audience } = useAudienceStore.getState();
    const { user } = useAuthStore.getState();

    if (user && user.audience) {
      if (user.audience !== "ADULT") {
        throw redirect({
          to: "/children/exercises",
        });
      }
    } else if (!audience) {
      throw redirect({
        to: "/audience",
      });
    } else if (audience === "CHILD") {
      throw redirect({
        to: "/children/exercises",
      });
    }

    return {
      audience: "adult" as const,
    } satisfies AdultRouteContext;
  },
  component: AdultLayout,
});

function AdultLayout() {
  return <Outlet />;
}
